// extracted by css-extract-rspack-plugin
export default {"option":"fzvrc","form":"_7DNp","formFixedHeight":"sRZgZ","modalBody":"japhP"};